import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/proxy/searchCruises', request, cancelToken)
}

export {get}
